<template>
  <div>
    <p>Follow the complete journey of messages through your distributed system:</p>
    <ul>
      <li><strong>Conversation tracking</strong> - See all related messages grouped together by conversation ID</li>
      <li><strong>Message timeline</strong> - View the sequence of events as messages flow between endpoints</li>
      <li><strong>Endpoint mapping</strong> - Understand which endpoints send and receive each message type</li>
      <li><strong>Flow visualization</strong> - Get a clear picture of your system's message-based interactions</li>
    </ul>
  </div>
</template>
